import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeFieldsRevisionSettingsDetailViewTopBar } from "./TopBar"

export const issueTypeFieldsRevisionSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeFieldsRevisionSettingsDetailViewTopBar,
}
